module.exports = __webpack_public_path__ + "static/8-471b7a55116419637bd30bfc5ec7589b.webp";